module.exports = require('./helpers/bundle-url').getBundleURL('kY0ao') + "logo.c51670a8.svg";